// eslint-disable-next-line @typescript-eslint/no-var-requires
import {  slashPathIndex } from "../../shared/constants/enginePaths";

const manifest = {
  ...require('../../apps.json'),
  ...require('../../apps.geograffee.json'),
};

const currentApp = localStorage.getItem('current-app')
const localhost = /localhost:\d+/
const DEFAULT_DEV_HOST = 'deziiign-ru.burgdev.ru'
const devHost = currentApp
  ? (Object.entries(manifest).find(([key, appItem]: any) => (appItem.mode === 'develop') && (appItem.application === currentApp)))?.[0] || DEFAULT_DEV_HOST
  : DEFAULT_DEV_HOST

export const getPathContext = (searchedContext: string = '') => {
  const location: any = window.location;
  const host = location?.host?.replace(localhost, devHost);
  let hostApp = manifest[host];

  // @ts-ignore
  const slashApp = slashPathIndex[hostApp.application];

  if (!slashApp) {
    return hostApp
  }
  const pathArr = searchedContext
    ? [searchedContext]
    : (location?.pathname?.length > 1) && location?.pathname?.replace('/', '')?.split('/') // возвращает ['design'] в https://gallllery.com/design
  const compareContextRaw = pathArr && pathArr.length && pathArr[0]

  const compareContext = slashApp[compareContextRaw];
  const isContext = !!compareContext

  if (!isContext) {
    return hostApp
  }

  const newApplication = compareContext;
  return { ...hostApp, application: newApplication, basename: `/${pathArr[0]}`, pathContext: compareContext }

}
// eslint-disable-next-line @typescript-eslint/no-var-requires
import {  slashPathIndex } from "../../shared/constants/enginePaths";

const manifest = {
  ...require('../../apps.json'),
  ...require('../../apps.geograffee.json'),
};

const currentApp = localStorage.getItem('current-app')
const localhost = /localhost:\d+/
const DEFAULT_DEV_HOST = 'deziiign-ru.burgdev.ru'
const devHost = currentApp
  ? (Object.entries(manifest).find(([key, appItem]: any) => (appItem.mode === 'develop') && (appItem.application === currentApp)))?.[0] || DEFAULT_DEV_HOST
  : DEFAULT_DEV_HOST

export const getPathContext = (searchedContext: string = '') => {
  const location: any = window.location;
  const host = location?.host?.replace(localhost, devHost);
  let hostApp = manifest[host];

  // @ts-ignore
  const slashApp = slashPathIndex[hostApp.application];

  if (!slashApp) {
    return hostApp
  }
  const pathArr = searchedContext
    ? [searchedContext]
    : (location?.pathname?.length > 1) && location?.pathname?.replace('/', '')?.split('/') // возвращает ['design'] в https://gallllery.com/design
  const compareContextRaw = pathArr && pathArr.length && pathArr[0]

  const compareContext = slashApp[compareContextRaw];
  const isContext = !!compareContext

  if (!isContext) {
    return hostApp
  }

  const newApplication = compareContext;
  return { ...hostApp, application: newApplication, basename: `/${pathArr[0]}`, pathContext: compareContext }

}
